import React from "react";
import { motion } from "framer-motion";
import { CONTACT } from "@/constants/testIds";
import { Linkedin, Instagram, Twitter, Mail, Phone } from "lucide-react";

export const Contact = () => {
  return (
    <section
      id="contact"
      data-testid={CONTACT.section}
      className="relative py-24 lg:py-40 bg-white"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-12">
          <div className="lg:col-span-3">
            <div className="flex items-center gap-2 mb-4">
              <span className="inline-block h-2 w-2 bg-[#002FA7]" />
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">
                Contact
              </span>
            </div>
            <p className="text-sm text-zinc-500">05 / 06</p>
          </div>
          <div className="lg:col-span-9">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500 mb-6">
              Have a project in mind?
            </p>
            <motion.a
              href="mailto:hello@akshaysalve.com"
              data-testid={CONTACT.emailLink}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="font-display block text-5xl sm:text-6xl lg:text-[9rem] tracking-tighter leading-[0.9] text-zinc-900 hover:text-[#002FA7] transition-colors break-all"
            >
              hello@
              <br />
              akshaysalve
              <span className="text-zinc-300">.com</span>
            </motion.a>
          </div>
        </div>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-px border border-zinc-200 bg-zinc-200">
          <a
            href="tel:+919999999999"
            data-testid={CONTACT.phoneLink}
            className="group bg-white p-8 hover:bg-zinc-900 hover:text-white transition-colors"
          >
            <Phone className="h-5 w-5 mb-6" />
            <div className="text-xs font-bold uppercase tracking-widest text-zinc-500 group-hover:text-zinc-400">
              Phone
            </div>
            <div className="mt-2 text-xl font-display tracking-tight">
              +91 99999 99999
            </div>
          </a>
          <a
            href="mailto:hello@akshaysalve.com"
            className="group bg-white p-8 hover:bg-zinc-900 hover:text-white transition-colors"
          >
            <Mail className="h-5 w-5 mb-6" />
            <div className="text-xs font-bold uppercase tracking-widest text-zinc-500 group-hover:text-zinc-400">
              Email
            </div>
            <div className="mt-2 text-xl font-display tracking-tight">
              hello@akshaysalve.com
            </div>
          </a>
          <div className="bg-white p-8">
            <div className="text-xs font-bold uppercase tracking-widest text-zinc-500 mb-6">
              Social
            </div>
            <div className="flex items-center gap-3">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noreferrer"
                data-testid={CONTACT.socialLinkedin}
                aria-label="LinkedIn"
                className="h-11 w-11 inline-flex items-center justify-center border border-zinc-900 hover:bg-zinc-900 hover:text-white transition-colors"
              >
                <Linkedin className="h-4 w-4" />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noreferrer"
                data-testid={CONTACT.socialInstagram}
                aria-label="Instagram"
                className="h-11 w-11 inline-flex items-center justify-center border border-zinc-900 hover:bg-zinc-900 hover:text-white transition-colors"
              >
                <Instagram className="h-4 w-4" />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noreferrer"
                data-testid={CONTACT.socialTwitter}
                aria-label="Twitter / X"
                className="h-11 w-11 inline-flex items-center justify-center border border-zinc-900 hover:bg-zinc-900 hover:text-white transition-colors"
              >
                <Twitter className="h-4 w-4" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
